export default __webpack_public_path__ + "static/media/1_0026.bdc941cb.webp";